import { Component, ChangeDetectionStrategy, Input, EventEmitter, Output, ViewChild, ElementRef, ChangeDetectorRef, forwardRef, Injector, ViewContainerRef, Directive, HostListener, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgControl, NG_VALUE_ACCESSOR, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import { OverlayPositionBuilder, Overlay, OverlayModule } from '@angular/cdk/overlay';
import { ComponentPortal, TemplatePortal, PortalModule } from '@angular/cdk/portal';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { v4 } from 'uuid';
import Cleave from 'cleave.js';
import 'cleave.js/dist/addons/cleave-phone.it';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TooltipComponent {
    /**
     * @return {?}
     */
    close() {
        if (this.onClose) {
            this.onClose();
        }
    }
}
TooltipComponent.decorators = [
    { type: Component, args: [{
                selector: 'wt-tooltip',
                template: "<div class=\"wt-tooltip\">\n  <div class=\"wt-tooltip__container\">\n    <span class=\"wt-text-bold-m\" [innerHTML]=\"text\"></span>\n  </div>\n  <ng-container *ngIf=\"showCloseButton\">\n    <div class=\"wt-tooltip__close\" (click)=\"close()\"></div>\n  </ng-container>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }] }
];
TooltipComponent.propDecorators = {
    text: [{ type: Input }],
    showCloseButton: [{ type: Input }],
    onClose: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    TooltipComponent.prototype.text;
    /** @type {?} */
    TooltipComponent.prototype.showCloseButton;
    /** @type {?} */
    TooltipComponent.prototype.onClose;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SpinnerComponent {
}
SpinnerComponent.decorators = [
    { type: Component, args: [{
                selector: 'wt-spinner',
                template: "<div class=\"wt-spinner\">\n  <div class=\"wt-spinner__main\"></div>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AccordionComponent {
    constructor() {
        this.cssClasses = [];
        this.isOpen = false;
        this.toggle = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.setContentHeight(this.isOpen);
    }
    /**
     * @return {?}
     */
    toggleIsOpen() {
        this.isOpen = !this.isOpen;
        this.setContentHeight(this.isOpen);
        this.toggle.emit(this.isOpen);
    }
    /**
     * @private
     * @param {?} isOpen
     * @return {?}
     */
    setContentHeight(isOpen) {
        this.contentHeight = isOpen ? this.contentElement.nativeElement.scrollHeight : 0;
    }
}
AccordionComponent.decorators = [
    { type: Component, args: [{
                selector: 'wt-accordion',
                template: "<div class=\"wt-accordion\"\n     [ngClass]=\"cssClasses\"\n  >\n  <div class=\"wt-accordion__title\" [class.wt-accordion__title--open]=\"isOpen\" (click)=\"toggleIsOpen()\">\n    <ng-content select=\"[wt-accordion-title]\"></ng-content>\n  </div>\n  <div class=\"wt-accordion__content\" #content [style.max-height.px]=\"contentHeight\">\n    <div class=\"wt-accordion__content__container\">\n      <ng-content select=\"[wt-accordion-content]\"></ng-content>\n    </div>\n  </div>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }] }
];
AccordionComponent.propDecorators = {
    cssClasses: [{ type: Input }],
    isOpen: [{ type: Input }],
    toggle: [{ type: Output }],
    contentElement: [{ type: ViewChild, args: ['content', { static: true },] }]
};
if (false) {
    /** @type {?} */
    AccordionComponent.prototype.cssClasses;
    /** @type {?} */
    AccordionComponent.prototype.isOpen;
    /** @type {?} */
    AccordionComponent.prototype.toggle;
    /** @type {?} */
    AccordionComponent.prototype.contentElement;
    /** @type {?} */
    AccordionComponent.prototype.contentHeight;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class BacklinkComponent {
}
BacklinkComponent.decorators = [
    { type: Component, args: [{
                selector: 'wt-backlink',
                template: "<div class=\"wt-backlink\">\n  <a class=\"wt-backlink__link\" [href]=\"url\">\n    <div class=\"wt-backlink__container\">\n      <div class=\"wt-backlink__icon\"></div>\n      <div class=\"wt-text-base-s wt-backlink__label\">{{label}}</div>\n    </div>\n  </a>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }] }
];
BacklinkComponent.propDecorators = {
    url: [{ type: Input }],
    label: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    BacklinkComponent.prototype.url;
    /** @type {?} */
    BacklinkComponent.prototype.label;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const BUTTON_HOST_ATTRIBUTES_CLASS = {
    'wt-primary': 'wt-button--primary',
    'wt-default': 'wt-button--default',
    'wt-big': 'wt-button--big'
};
/** @type {?} */
const BUTTON_HOST_ATTRIBUTES = [
    'wt-primary',
    'wt-default',
    'wt-big'
];
class ButtonComponent {
    /**
     * @param {?} elementRef
     */
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.type = 'button';
        this.additionalClasses = [];
    }
    /**
     * @private
     * @param {?} hostAttribute
     * @return {?}
     */
    static getClassFromHostAttribute(hostAttribute) {
        return BUTTON_HOST_ATTRIBUTES_CLASS[hostAttribute] || 'wt-button--default';
    }
    /**
     * @private
     * @return {?}
     */
    get hostElement() {
        return this.elementRef.nativeElement;
    }
    /**
     * @private
     * @param {...?} attributes
     * @return {?}
     */
    hasHostAttributes(...attributes) {
        return attributes.some((/**
         * @param {?} attribute
         * @return {?}
         */
        attribute => this.hostElement.hasAttribute(attribute)));
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.additionalClasses = this.cssClasses || [];
        for (const attr of BUTTON_HOST_ATTRIBUTES) {
            if (this.hasHostAttributes(attr)) {
                /** @type {?} */
                const classFromAttribute = ButtonComponent.getClassFromHostAttribute(attr);
                this.additionalClasses = [...this.additionalClasses, classFromAttribute];
            }
        }
    }
}
ButtonComponent.decorators = [
    { type: Component, args: [{
                selector: 'wt-button',
                template: "<button class=\"wt-button\"\n        [type]=\"type\"\n        [class.wt-button--disabled]=\"disabled\"\n        [ngClass]=\"additionalClasses\"\n        [disabled]=\"disabled\"\n>\n  <ng-content></ng-content>\n</button>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }] }
];
/** @nocollapse */
ButtonComponent.ctorParameters = () => [
    { type: ElementRef }
];
ButtonComponent.propDecorators = {
    type: [{ type: Input }],
    disabled: [{ type: Input }],
    cssClasses: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    ButtonComponent.prototype.type;
    /** @type {?} */
    ButtonComponent.prototype.disabled;
    /** @type {?} */
    ButtonComponent.prototype.cssClasses;
    /** @type {?} */
    ButtonComponent.prototype.additionalClasses;
    /**
     * @type {?}
     * @private
     */
    ButtonComponent.prototype.elementRef;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const INPUT_BASE_ERROR_PREFIX = 'wt-input-error-';
/** @enum {string} */
const INPUT_DATE_TYPE = {
    DayMonthYear: 'DayMonthYear',
    MonthYear: 'MonthYear',
};
/** @enum {string} */
const INPUT_SIZES = {
    small: 's',
    medium: 'm',
    large: 'l',
};
/** @enum {string} */
const INPUT_WEIGHTS = {
    light: 'light',
    regular: 'base',
    medium: 'medium',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FooterComponent {
    /**
     * @return {?}
     */
    ngOnInit() {
        this.copyrightSize = INPUT_SIZES[this.copyrightSize] || INPUT_SIZES.small;
        this.copyrightWeight = INPUT_WEIGHTS[this.copyrightWeight] || INPUT_WEIGHTS.regular;
    }
}
FooterComponent.decorators = [
    { type: Component, args: [{
                selector: 'wt-footer',
                template: "<footer class=\"wt-footer\">\n  <div class=\"wt-footer__links\">\n    <div class=\"wt-footer__content-container\">\n      <div class=\"wt-text-base-s wt-footer__links__faq\">\n        Consulta le <a href=\"https://www.wind.it/privati/mobile/assistenza/\" target=\"_blank\" rel=\"noopener noreferrer\">FAQ</a>\n      </div>\n      <div class=\"wt-text-base-s wt-footer__links__legal--one\">\n        <a href=\"https://www.wind.it/privati/condizioni-ecommerce/\" target=\"_blank\" rel=\"noopener noreferrer\">Condizioni generali di acquisto online</a>\n      </div>\n      <span class=\"wt-text-base-s wt-footer__links__legal--span\"> | </span>\n      <div class=\"wt-text-base-s wt-footer__links__legal--two\">\n        <a href=\"https://d1092lx8qlatoa.cloudfront.net/mailsupport/doc/wind_3_spa_recesso_fp.pdf\" target=\"_blank\" rel=\"noopener noreferrer\">Diritto di recesso</a>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"wt-footer__info\">\n    <div class=\"wt-footer__content-container wt-footer__content-container--info\">\n      <figure class=\"wt-footer__info__logo\"></figure>\n      <div class=\"wt-footer__info__copyright\">\n        <span class=\"wt-text-{{copyrightWeight}}-{{copyrightSize}}\">Wind Tre S.p.A. - P.IVA n. 13378520152</span>\n      </div>\n    </div>\n  </div>\n</footer>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }] }
];
FooterComponent.propDecorators = {
    copyrightSize: [{ type: Input }],
    copyrightWeight: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    FooterComponent.prototype.copyrightSize;
    /** @type {?} */
    FooterComponent.prototype.copyrightWeight;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class HeaderComponent {
}
HeaderComponent.decorators = [
    { type: Component, args: [{
                selector: 'wt-header',
                template: "<header>\n  <div class=\"wt-header\">\n    <div class=\"wt-header__container\">\n      <div class=\"wt-header__container__image\"></div>\n    </div>\n  </div>\n</header>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InfoBoxComponent {
}
InfoBoxComponent.decorators = [
    { type: Component, args: [{
                selector: 'wt-info-box',
                template: "<div class=\"wt-info-box\">\n  <div class=\"wt-info-box__container\">\n    <ng-content></ng-content>\n  </div>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InfoNoteComponent {
    /**
     * @param {?} cdr
     * @param {?} overlayPositionBuilder
     * @param {?} elementRef
     * @param {?} overlay
     */
    constructor(cdr, overlayPositionBuilder, elementRef, overlay) {
        this.cdr = cdr;
        this.overlayPositionBuilder = overlayPositionBuilder;
        this.elementRef = elementRef;
        this.overlay = overlay;
        this.subscriptions = new Subscription();
        this.tooltipClick = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.setTooltipPosition();
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    /**
     * @return {?}
     */
    toggle() {
        if (this.text) {
            if (this.isOpen) {
                this.overlayRef.detach();
            }
            else {
                /** @type {?} */
                const tooltipPortal = new ComponentPortal(TooltipComponent);
                /** @type {?} */
                const tooltipRef = this.overlayRef.attach(tooltipPortal);
                tooltipRef.instance.text = this.text;
                tooltipRef.instance.showCloseButton = this.showCloseButton;
                tooltipRef.instance.onClose = (/**
                 * @return {?}
                 */
                () => this.closeTooltip());
            }
            this.isOpen = !this.isOpen;
        }
        this.tooltipClick.emit();
    }
    /**
     * @return {?}
     */
    closeTooltip() {
        this.overlayRef.detach();
    }
    /**
     * @private
     * @return {?}
     */
    setTooltipPosition() {
        /** @type {?} */
        const hasBackdrop = true;
        /** @type {?} */
        const backdropClass = '';
        /** @type {?} */
        let panelClass;
        /** @type {?} */
        const width = this.width || undefined;
        /** @type {?} */
        const scrollStrategy = this.overlay.scrollStrategies.close();
        /** @type {?} */
        let positionStrategy;
        if (this.invert) {
            positionStrategy = this.overlayPositionBuilder
                .flexibleConnectedTo(this.elementRef)
                .withLockedPosition(true)
                .withPositions([{
                    originX: 'start',
                    originY: 'top',
                    overlayX: 'end',
                    overlayY: 'bottom',
                    offsetY: -10,
                    offsetX: 10
                }]);
            panelClass = 'custom-overlay';
        }
        else {
            positionStrategy = this.overlayPositionBuilder
                .flexibleConnectedTo(this.elementRef)
                .withLockedPosition(false)
                .withPositions([{
                    originX: 'center',
                    originY: 'bottom',
                    overlayX: 'center',
                    overlayY: 'top',
                    offsetY: 5
                }]);
        }
        // Overlay creation
        this.overlayRef = this.overlay.create({
            positionStrategy,
            hasBackdrop,
            backdropClass,
            scrollStrategy,
            panelClass,
            width
        });
        // Overlay on close behaviour
        this.subscriptions.add(this.overlayRef.detachments().subscribe((/**
         * @return {?}
         */
        () => {
            this.toggle();
            this.cdr.detectChanges();
        })));
        this.subscriptions.add(this.overlayRef.backdropClick().subscribe((/**
         * @return {?}
         */
        () => {
            this.overlayRef.detach();
        })));
    }
}
InfoNoteComponent.decorators = [
    { type: Component, args: [{
                selector: 'wt-info-note',
                template: "<div class=\"wt-info-note\" [class.wt-info-note--opened]=\"isOpen\" [class.wt-info-note--invert]=\"invert\">\n  <div class=\"wt-info-note__icon\" (click)=\"toggle()\"></div>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }] }
];
/** @nocollapse */
InfoNoteComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: OverlayPositionBuilder },
    { type: ElementRef },
    { type: Overlay }
];
InfoNoteComponent.propDecorators = {
    invert: [{ type: Input }],
    width: [{ type: Input }],
    text: [{ type: Input }],
    showCloseButton: [{ type: Input }],
    tooltipClick: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    InfoNoteComponent.prototype.isOpen;
    /**
     * @type {?}
     * @private
     */
    InfoNoteComponent.prototype.overlayRef;
    /**
     * @type {?}
     * @private
     */
    InfoNoteComponent.prototype.subscriptions;
    /** @type {?} */
    InfoNoteComponent.prototype.invert;
    /** @type {?} */
    InfoNoteComponent.prototype.width;
    /** @type {?} */
    InfoNoteComponent.prototype.text;
    /** @type {?} */
    InfoNoteComponent.prototype.showCloseButton;
    /** @type {?} */
    InfoNoteComponent.prototype.tooltipClick;
    /**
     * @type {?}
     * @private
     */
    InfoNoteComponent.prototype.cdr;
    /**
     * @type {?}
     * @private
     */
    InfoNoteComponent.prototype.overlayPositionBuilder;
    /**
     * @type {?}
     * @private
     */
    InfoNoteComponent.prototype.elementRef;
    /**
     * @type {?}
     * @private
     */
    InfoNoteComponent.prototype.overlay;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 */
class InputBaseComponent {
    /**
     * @protected
     * @param {?} injector
     */
    constructor(injector) {
        this.injector = injector;
        this.keyupChange = new EventEmitter();
        this.id = `input_${v4()}`;
        this.subscriptions = new Subscription();
        this.ref = (/** @type {?} */ ({
            markForCheck: (/**
             * @return {?}
             */
            () => {
            })
        }));
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this.setFormControl();
        this.setInjectedServices();
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    /**
     * @return {?}
     */
    get errorMessage() {
        const [firstErrorKey] = Object.keys(this.formControl.errors || {});
        /** @type {?} */
        const errorLabelKey = `${INPUT_BASE_ERROR_PREFIX}${firstErrorKey}`;
        return this.translateService ? this.translateService.instant(errorLabelKey) : errorLabelKey;
    }
    /**
     * @return {?}
     */
    get isInvalid() {
        return Boolean(this.formControl && this.formControl.errors && this.formControl.touched);
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    onKeyup($event) {
        this.keyupChange.emit($event);
    }
    /**
     * @return {?}
     */
    onFocus() {
        this.isFocused = true;
        this.formControl.updateValueAndValidity();
    }
    /**
     * @private
     * @return {?}
     */
    setInjectedServices() {
        this.translateService = this.injector.get((/** @type {?} */ (TranslateService)), null);
        this.ref = this.injector.get((/** @type {?} */ (ChangeDetectorRef)), null);
        if (this.ref) {
            // Detect changes to show pending error (if present)
            this.ref.detectChanges();
        }
    }
    /**
     * @private
     * @return {?}
     */
    setFormControl() {
        /** @type {?} */
        const ngControl = this.injector.get((/** @type {?} */ (NgControl)));
        if (ngControl) {
            this.formControl = (/** @type {?} */ (ngControl.control));
            this.subscriptions.add(this.formControl.statusChanges.subscribe((/**
             * @return {?}
             */
            () => {
                this.ref.markForCheck();
            })));
        }
        else {
            throw Error('Missing ngControl');
        }
    }
}
InputBaseComponent.propDecorators = {
    label: [{ type: Input }],
    ariaLabel: [{ type: Input }],
    maxLength: [{ type: Input }],
    validateOnBlur: [{ type: Input }],
    keyupChange: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    InputBaseComponent.prototype.label;
    /** @type {?} */
    InputBaseComponent.prototype.ariaLabel;
    /** @type {?} */
    InputBaseComponent.prototype.maxLength;
    /** @type {?} */
    InputBaseComponent.prototype.validateOnBlur;
    /** @type {?} */
    InputBaseComponent.prototype.keyupChange;
    /** @type {?} */
    InputBaseComponent.prototype.id;
    /** @type {?} */
    InputBaseComponent.prototype.formControl;
    /** @type {?} */
    InputBaseComponent.prototype.isFocused;
    /**
     * @type {?}
     * @private
     */
    InputBaseComponent.prototype.subscriptions;
    /**
     * @type {?}
     * @private
     */
    InputBaseComponent.prototype.translateService;
    /**
     * @type {?}
     * @protected
     */
    InputBaseComponent.prototype.ref;
    /**
     * @type {?}
     * @protected
     */
    InputBaseComponent.prototype.injector;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const HOST_ATTRIBUTES_CLASS = {
    'wt-small': 'wt-input-checkbox--small'
};
/** @type {?} */
const HOST_ATTRIBUTES = [
    'wt-small'
];
class InputCheckboxComponent extends InputBaseComponent {
    /**
     * @param {?} injector
     * @param {?} elementRef
     */
    constructor(injector, elementRef) {
        super(injector);
        this.elementRef = elementRef;
        this.additionalClasses = [];
        this.clicked = new EventEmitter();
        for (const attr of HOST_ATTRIBUTES) {
            if (this.hasHostAttributes(attr)) {
                /** @type {?} */
                const classFromAttribute = InputCheckboxComponent.getClassFromHostAttribute(attr);
                this.additionalClasses = [...this.additionalClasses, classFromAttribute];
            }
        }
    }
    /**
     * @private
     * @param {?} hostAttribute
     * @return {?}
     */
    static getClassFromHostAttribute(hostAttribute) {
        return HOST_ATTRIBUTES_CLASS[hostAttribute] || 'wt-input-checkbox--default';
    }
    /**
     * @private
     * @return {?}
     */
    get hostElement() {
        return this.elementRef.nativeElement;
    }
    /**
     * @private
     * @param {...?} attributes
     * @return {?}
     */
    hasHostAttributes(...attributes) {
        return attributes.some((/**
         * @param {?} attribute
         * @return {?}
         */
        attribute => this.hostElement.hasAttribute(attribute)));
    }
    /**
     * @return {?}
     */
    get value() {
        return this.innerValue;
    }
    /**
     * @param {?} obj
     * @return {?}
     */
    set value(obj) {
        if (obj !== this.innerValue) {
            this.innerValue = obj;
            this.onChange(obj);
            this.onTouched(obj);
        }
    }
    /**
     * @param {?} obj
     * @return {?}
     */
    writeValue(obj) {
        if (obj !== this.innerValue) {
            this.innerValue = obj;
            this.ref.markForCheck();
        }
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnChange(fn) {
        this.onChange = fn;
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
}
InputCheckboxComponent.decorators = [
    { type: Component, args: [{
                selector: 'wt-input-checkbox',
                template: "<div class=\"wt-input-checkbox\"\n     [class.wt-input-checkbox--disabled]=\"disabled\"\n     [ngClass]=\"additionalClasses\"\n>\n  <input class=\"wt-form-checkbox\" type=\"checkbox\"\n         [id]=\"id\"\n         [disabled]=\"disabled\"\n         [(ngModel)]=\"value\"\n         (click)=\"clicked.emit()\"\n  >\n  <label class=\"wt-input-checkbox__label\"\n         [for]=\"id\"\n  >\n    <ng-content></ng-content>\n  </label>\n</div>\n\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef((/**
                         * @return {?}
                         */
                        () => InputCheckboxComponent)),
                        multi: true
                    }]
            }] }
];
/** @nocollapse */
InputCheckboxComponent.ctorParameters = () => [
    { type: Injector },
    { type: ElementRef }
];
InputCheckboxComponent.propDecorators = {
    disabled: [{ type: Input }],
    clicked: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    InputCheckboxComponent.prototype.innerValue;
    /** @type {?} */
    InputCheckboxComponent.prototype.onTouched;
    /** @type {?} */
    InputCheckboxComponent.prototype.onChange;
    /** @type {?} */
    InputCheckboxComponent.prototype.additionalClasses;
    /** @type {?} */
    InputCheckboxComponent.prototype.disabled;
    /** @type {?} */
    InputCheckboxComponent.prototype.clicked;
    /**
     * @type {?}
     * @private
     */
    InputCheckboxComponent.prototype.elementRef;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InputCreditcardComponent extends InputBaseComponent {
    /**
     * @param {?} injector
     */
    constructor(injector) {
        super(injector);
    }
    /**
     * @return {?}
     */
    get isFilled() {
        return (this.innerValue || this.placeholder);
    }
    /**
     * @return {?}
     */
    get value() {
        return this.innerValue;
    }
    /**
     * @param {?} obj
     * @return {?}
     */
    set value(obj) {
        if (obj !== this.innerValue) {
            this.innerValue = this.sanitizeValue(obj);
            /** @type {?} */
            const rawValue = this.cleave ? this.sanitizeValue(this.cleave.getRawValue()) : obj;
            this.onChange(rawValue);
            this.onTouched(rawValue);
        }
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.cleave = new Cleave(this.inputElement.nativeElement, {
            creditCard: true,
            delimiter: ' - ',
            onCreditCardTypeChanged: (/**
             * @param {?} type
             * @return {?}
             */
            (type) => {
                /** @type {?} */
                const UNIDENTIFIED_CREDIT_CARD_TYPE = 'unknown';
                this.creditCardType = type || UNIDENTIFIED_CREDIT_CARD_TYPE;
            })
        });
        if (this.innerValue) {
            this.cleave.setRawValue(String(this.innerValue));
            this.innerValue = this.cleave.getFormattedValue();
            this.ref.detectChanges();
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.cleave.destroy();
    }
    /**
     * @param {?} obj
     * @return {?}
     */
    writeValue(obj) {
        if (obj !== this.innerValue) {
            this.innerValue = obj;
            if (this.cleave) {
                this.cleave.setRawValue(String(this.innerValue));
                this.innerValue = this.cleave.getFormattedValue();
            }
            this.ref.markForCheck();
        }
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnChange(fn) {
        this.onChange = fn;
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    /**
     * @private
     * @param {?} obj
     * @return {?}
     */
    sanitizeValue(obj) {
        return (obj || '').replace(/[^0-9]/, '');
    }
}
InputCreditcardComponent.decorators = [
    { type: Component, args: [{
                selector: 'wt-input-creditcard',
                template: "<div class=\"wt-input wt-input-creditcard\">\n  <input class=\"wt-input__input\" type=\"tel\"\n         [id]=\"id\"\n         [class.wt-input__input--filled]=\"isFilled\"\n         [attr.aria-label]=\"ariaLabel ? ariaLabel : null\"\n         [attr.placeholder]=\"placeholder ? placeholder : null\"\n         [attr.maxlength]=\"maxLength ? maxLength : null\"\n         [disabled]=\"disabled\"\n         (blur)=\"onTouched(value)\"\n         (keyup)=\"onKeyup(value)\"\n         [(ngModel)]=\"value\"\n         #inputCreditCard\n  />\n  <label class=\"wt-input__label\"\n         *ngIf=\"label\"\n         [for]=\"id\"\n  >\n    {{label}}\n  </label>\n  <div class=\"wt-input-creditcard__type wt-input-creditcard__type--{{creditCardType}}\"></div>\n  <div class=\"wt-input__error\" *ngIf=\"isInvalid\">\n    {{errorMessage}}\n  </div>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef((/**
                         * @return {?}
                         */
                        () => InputCreditcardComponent)),
                        multi: true
                    }]
            }] }
];
/** @nocollapse */
InputCreditcardComponent.ctorParameters = () => [
    { type: Injector }
];
InputCreditcardComponent.propDecorators = {
    disabled: [{ type: Input }],
    placeholder: [{ type: Input }],
    inputElement: [{ type: ViewChild, args: ['inputCreditCard', { static: true },] }]
};
if (false) {
    /** @type {?} */
    InputCreditcardComponent.prototype.disabled;
    /** @type {?} */
    InputCreditcardComponent.prototype.placeholder;
    /** @type {?} */
    InputCreditcardComponent.prototype.inputElement;
    /** @type {?} */
    InputCreditcardComponent.prototype.onTouched;
    /** @type {?} */
    InputCreditcardComponent.prototype.onChange;
    /** @type {?} */
    InputCreditcardComponent.prototype.innerValue;
    /** @type {?} */
    InputCreditcardComponent.prototype.cleave;
    /** @type {?} */
    InputCreditcardComponent.prototype.creditCardType;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InputDateComponent extends InputBaseComponent {
    /**
     * @param {?} injector
     */
    constructor(injector) {
        super(injector);
    }
    /**
     * @return {?}
     */
    get isFilled() {
        return (this.innerValue);
    }
    /**
     * @return {?}
     */
    get isPlaceholder() {
        return (this.placeholder);
    }
    /**
     * @return {?}
     */
    get value() {
        return this.innerValue;
    }
    /**
     * @param {?} obj
     * @return {?}
     */
    set value(obj) {
        if (obj !== this.innerValue) {
            this.innerValue = this.sanitizeValue(obj);
            this.onChange(this.innerValue);
            this.onTouched(this.innerValue);
        }
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    onBlur($event) {
        this.isFocused = false;
        this.onTouched($event);
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        switch (this.dateType) {
            case 'DayMonthYear':
                this.selectedDateType = ['d', 'm', 'Y'];
                break;
            case 'MonthYear':
                this.selectedDateType = ['m', 'y'];
                break;
            default:
                this.selectedDateType = ['d', 'm', 'Y'];
                break;
        }
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.cleave = new Cleave(this.inputElement.nativeElement, {
            date: true,
            dateMax: this.dateMax,
            dateMin: this.dateMin,
            delimiter: '/',
            datePattern: this.selectedDateType
        });
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        super.ngOnDestroy();
        this.cleave.destroy();
    }
    /**
     * @param {?} obj
     * @return {?}
     */
    writeValue(obj) {
        if (obj !== this.innerValue) {
            this.innerValue = obj;
            this.ref.markForCheck();
        }
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnChange(fn) {
        this.onChange = fn;
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    /**
     * @private
     * @param {?} obj
     * @return {?}
     */
    sanitizeValue(obj) {
        if (!this.cleave) {
            return obj;
        }
        return (this.cleave.getFormattedValue() || '').replace(/[^0-9\/]/, '');
    }
}
InputDateComponent.decorators = [
    { type: Component, args: [{
                selector: 'wt-input-date',
                template: "<div class=\"wt-input wt-input-date\"\n     [class.wt-input--validate-on-blur]=\"validateOnBlur\"\n     [class.wt-input--focused]=\"isFocused\">\n  <input class=\"wt-input__input\" type=\"text\"\n         [id]=\"id\"\n         [class.wt-input__input--filled]=\"isFilled\"\n         [class.wt-input__input--placeholder]=\"isPlaceholder\"\n         [attr.aria-label]=\"ariaLabel ? ariaLabel : null\"\n         [disabled]=\"disabled\"\n         [placeholder]=\"placeholder\"\n         (blur)=\"onBlur(value)\"\n         (focus)=\"onFocus()\"\n         (keyup)=\"onKeyup(value)\"\n         [(ngModel)]=\"value\"\n         #inputDate\n  />\n  <label class=\"wt-input__label\"\n         *ngIf=\"label\"\n         [for]=\"id\"\n  >\n    {{label}}\n  </label>\n  <div class=\"wt-input__error\" *ngIf=\"isInvalid && (!validateOnBlur || !isFocused)\">\n    {{errorMessage}}\n  </div>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef((/**
                         * @return {?}
                         */
                        () => InputDateComponent)),
                        multi: true
                    }]
            }] }
];
/** @nocollapse */
InputDateComponent.ctorParameters = () => [
    { type: Injector }
];
InputDateComponent.propDecorators = {
    dateMax: [{ type: Input }],
    dateMin: [{ type: Input }],
    disabled: [{ type: Input }],
    placeholder: [{ type: Input }],
    dateType: [{ type: Input }],
    inputElement: [{ type: ViewChild, args: ['inputDate', { static: true },] }]
};
if (false) {
    /** @type {?} */
    InputDateComponent.prototype.dateMax;
    /** @type {?} */
    InputDateComponent.prototype.dateMin;
    /** @type {?} */
    InputDateComponent.prototype.disabled;
    /** @type {?} */
    InputDateComponent.prototype.placeholder;
    /** @type {?} */
    InputDateComponent.prototype.dateType;
    /** @type {?} */
    InputDateComponent.prototype.inputElement;
    /** @type {?} */
    InputDateComponent.prototype.onTouched;
    /**
     * @type {?}
     * @private
     */
    InputDateComponent.prototype.cleave;
    /**
     * @type {?}
     * @private
     */
    InputDateComponent.prototype.selectedDateType;
    /**
     * @type {?}
     * @private
     */
    InputDateComponent.prototype.onChange;
    /**
     * @type {?}
     * @private
     */
    InputDateComponent.prototype.innerValue;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InputRadioComponent extends InputBaseComponent {
    /**
     * @param {?} injector
     */
    constructor(injector) {
        super(injector);
    }
    /**
     * @return {?}
     */
    get isChecked() {
        return this.modelValue === this.value;
    }
    /**
     * @return {?}
     */
    get modelValue() {
        return this.innerValue;
    }
    /**
     * @param {?} obj
     * @return {?}
     */
    set modelValue(obj) {
        this.innerValue = obj;
        this.onChange(obj);
        this.onTouched(obj);
    }
    /**
     * @param {?} obj
     * @return {?}
     */
    writeValue(obj) {
        this.innerValue = obj;
        this.ref.markForCheck();
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnChange(fn) {
        this.onChange = fn;
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
}
InputRadioComponent.decorators = [
    { type: Component, args: [{
                selector: 'wt-input-radio',
                template: "<div class=\"wt-input-radio\"\n     [class.wt-input-radio--html]=\"isHTML\"\n     [class.wt-input-radio--disabled]=\"disabled\">\n  <input type=\"radio\"\n         class=\"wt-input-radio__input\"\n         [id]=\"id\"\n         [name]=\"groupName\"\n         [value]=\"value\"\n         [disabled]=\"disabled\"\n         [attr.aria-label]=\"ariaLabel ? ariaLabel : null\"\n         [checked]=\"isChecked\"\n         [(ngModel)]=\"modelValue\">\n  <label class=\"wt-input-radio__label\" [for]=\"id\">\n    <ng-content></ng-content>\n  </label>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef((/**
                         * @return {?}
                         */
                        () => InputRadioComponent)),
                        multi: true
                    }]
            }] }
];
/** @nocollapse */
InputRadioComponent.ctorParameters = () => [
    { type: Injector }
];
InputRadioComponent.propDecorators = {
    groupName: [{ type: Input }],
    value: [{ type: Input }],
    disabled: [{ type: Input }],
    isHTML: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    InputRadioComponent.prototype.groupName;
    /** @type {?} */
    InputRadioComponent.prototype.value;
    /** @type {?} */
    InputRadioComponent.prototype.disabled;
    /** @type {?} */
    InputRadioComponent.prototype.isHTML;
    /** @type {?} */
    InputRadioComponent.prototype.onTouched;
    /** @type {?} */
    InputRadioComponent.prototype.onChange;
    /** @type {?} */
    InputRadioComponent.prototype.innerValue;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InputSelectAutocompleteComponent extends InputBaseComponent {
    /**
     * @param {?} injector
     */
    constructor(injector) {
        super(injector);
        this.loadingText = 'Caricamento...';
        this.search = new EventEmitter();
        this.change = new EventEmitter();
    }
    /**
     * @return {?}
     */
    get isFilled() {
        return Boolean(this.formControl && this.formControl.value);
    }
    /**
     * @param {?} payload
     * @return {?}
     */
    onSearch(payload) {
        this.search.emit(payload.term);
    }
    /**
     * @param {?} payload
     * @return {?}
     */
    onChange(payload) {
        this.change.emit(payload);
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnChange(fn) {
        this.ngSelectComponentRef.registerOnChange(fn);
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnTouched(fn) {
        this.ngSelectComponentRef.registerOnTouched(fn);
    }
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    setDisabledState(isDisabled) {
        this.ngSelectComponentRef.setDisabledState(isDisabled);
        this.disabled = isDisabled;
        if (isDisabled) {
            this.isOpen = false;
        }
    }
    /**
     * @param {?} obj
     * @return {?}
     */
    writeValue(obj) {
        this.ngSelectComponentRef.writeValue(obj);
    }
}
InputSelectAutocompleteComponent.decorators = [
    { type: Component, args: [{
                selector: 'wt-input-select-autocomplete',
                template: "<div class=\"wt-input wt-input-select-autocomplete\">\n  <ng-select class=\"wt-input__input wt-input-select-autocomplete__input\"\n             [class.wt-input__input--filled]=\"isFilled\"\n             [id]=\"id\"\n             [items]=\"items\"\n             [bindValue]=\"bindValue\"\n             [bindLabel]=\"bindLabel\"\n             [placeholder]=\"placeholder\"\n             [loadingText]=\"loadingText\"\n             [notFoundText]=\"notFoundText\"\n             [loading]=\"loading\"\n             [isOpen]=\"isOpen\"\n             [searchable]=\"!disabled\"\n             (search)=\"onSearch($event)\"\n             (change)=\"onChange($event)\"\n             [clearable]=\"false\"\n             dropdownPosition=\"bottom\"\n  >\n  </ng-select>\n\n  <label class=\"wt-input__label wt-input-select-autocomplete__label\"\n         *ngIf=\"label\"\n         [for]=\"id\"\n  >\n    {{label}}\n  </label>\n\n  <div class=\"wt-input__error\"\n       *ngIf=\"isInvalid\"\n  >\n    {{errorMessage}}\n  </div>\n</div>\n\n",
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef((/**
                         * @return {?}
                         */
                        () => InputSelectAutocompleteComponent)),
                        multi: true
                    }]
            }] }
];
/** @nocollapse */
InputSelectAutocompleteComponent.ctorParameters = () => [
    { type: Injector }
];
InputSelectAutocompleteComponent.propDecorators = {
    ngSelectComponentRef: [{ type: ViewChild, args: [NgSelectComponent, { static: true },] }],
    bindLabel: [{ type: Input }],
    bindValue: [{ type: Input }],
    items: [{ type: Input }],
    loading: [{ type: Input }],
    loadingText: [{ type: Input }],
    notFoundText: [{ type: Input }],
    placeholder: [{ type: Input }],
    isOpen: [{ type: Input }],
    disabled: [{ type: Input }],
    search: [{ type: Output }],
    change: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    InputSelectAutocompleteComponent.prototype.ngSelectComponentRef;
    /** @type {?} */
    InputSelectAutocompleteComponent.prototype.bindLabel;
    /** @type {?} */
    InputSelectAutocompleteComponent.prototype.bindValue;
    /** @type {?} */
    InputSelectAutocompleteComponent.prototype.items;
    /** @type {?} */
    InputSelectAutocompleteComponent.prototype.loading;
    /** @type {?} */
    InputSelectAutocompleteComponent.prototype.loadingText;
    /** @type {?} */
    InputSelectAutocompleteComponent.prototype.notFoundText;
    /** @type {?} */
    InputSelectAutocompleteComponent.prototype.placeholder;
    /** @type {?} */
    InputSelectAutocompleteComponent.prototype.isOpen;
    /** @type {?} */
    InputSelectAutocompleteComponent.prototype.disabled;
    /** @type {?} */
    InputSelectAutocompleteComponent.prototype.search;
    /** @type {?} */
    InputSelectAutocompleteComponent.prototype.change;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InputSelectComponent extends InputBaseComponent {
    /**
     * @param {?} injector
     */
    constructor(injector) {
        super(injector);
        this.bindLabel = 'name';
        this.bindValue = 'id';
        this.placeholder = '';
    }
    /**
     * @return {?}
     */
    get isFilled() {
        return Boolean(this.formControl && this.formControl.value);
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnChange(fn) {
        this.ngSelectComponentRef.registerOnChange(fn);
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnTouched(fn) {
        this.ngSelectComponentRef.registerOnTouched(fn);
    }
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    setDisabledState(isDisabled) {
        this.ngSelectComponentRef.setDisabledState(isDisabled);
        this.disabled = isDisabled;
        if (isDisabled) {
            this.isOpen = false;
        }
    }
    /**
     * @param {?} obj
     * @return {?}
     */
    writeValue(obj) {
        this.ngSelectComponentRef.writeValue(obj);
    }
    /**
     * @return {?}
     */
    onFocus() {
        if (!this.ngSelectComponentRef) {
            console.warn('Missing NgSelectComponent ref');
            return;
        }
        this.ngSelectComponentRef.focus();
        setTimeout((/**
         * @return {?}
         */
        () => {
            // @ts-ignore
            this.ngSelectComponentRef._manualOpen = false;
            // Postpone open event (focus event does prevent open event)
            this.ngSelectComponentRef.open();
        }), 0);
    }
}
InputSelectComponent.decorators = [
    { type: Component, args: [{
                selector: 'wt-input-select',
                template: "<div class=\"wt-input wt-input-select\">\n  <ng-select\n             [class.wt-input__input--filled]=\"isFilled\"\n             [id]=\"id\"\n             [items]=\"items\"\n             [searchable]=\"false\"\n             [bindValue]=\"bindValue\"\n             [bindLabel]=\"bindLabel\"\n             [placeholder]=\"placeholder\"\n             [isOpen]=\"isOpen\"\n             [clearable]=\"false\"\n             (focus)=\"onFocus()\"\n             dropdownPosition=\"bottom\"\n  >\n  </ng-select>\n\n  <label class=\"wt-input__label wt-input-select__label wt-text-base-s\"\n         *ngIf=\"label && isFilled\"\n         [for]=\"id\"\n  >\n    {{label}}\n  </label>\n\n  <div class=\"wt-input__error\"\n       *ngIf=\"isInvalid\"\n  >\n    {{errorMessage}}\n  </div>\n</div>\n",
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef((/**
                         * @return {?}
                         */
                        () => InputSelectComponent)),
                        multi: true
                    }]
            }] }
];
/** @nocollapse */
InputSelectComponent.ctorParameters = () => [
    { type: Injector }
];
InputSelectComponent.propDecorators = {
    ngSelectComponentRef: [{ type: ViewChild, args: [NgSelectComponent, { static: true },] }],
    bindLabel: [{ type: Input }],
    bindValue: [{ type: Input }],
    disabled: [{ type: Input }],
    isOpen: [{ type: Input }],
    items: [{ type: Input }],
    placeholder: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    InputSelectComponent.prototype.ngSelectComponentRef;
    /** @type {?} */
    InputSelectComponent.prototype.bindLabel;
    /** @type {?} */
    InputSelectComponent.prototype.bindValue;
    /** @type {?} */
    InputSelectComponent.prototype.disabled;
    /** @type {?} */
    InputSelectComponent.prototype.isOpen;
    /** @type {?} */
    InputSelectComponent.prototype.items;
    /** @type {?} */
    InputSelectComponent.prototype.placeholder;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InputTextComponent extends InputBaseComponent {
    /**
     * @param {?} injector
     */
    constructor(injector) {
        super(injector);
        this.type = 'text';
        this.inferredType = 'text';
    }
    /**
     * @return {?}
     */
    get value() {
        return this.innerValue;
    }
    /**
     * @param {?} obj
     * @return {?}
     */
    set value(obj) {
        if (obj !== this.innerValue) {
            this.innerValue = this.sanitizeValue(obj);
            this.onChange(this.innerValue);
            this.onTouched(this.innerValue);
        }
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        super.ngAfterViewInit();
        // Infer cleave configuration and set input type
        /** @type {?} */
        let inferredCleaveConfiguration = null;
        switch (this.type) {
            case 'tel': {
                this.inferredType = 'tel';
                inferredCleaveConfiguration = {
                    phone: true,
                    phoneRegionCode: 'IT'
                };
                break;
            }
            case 'number': {
                this.inferredType = 'number';
                inferredCleaveConfiguration = {
                    numeral: true,
                    numeralThousandsGroupStyle: 'none',
                    stripLeadingZeroes: false
                };
                break;
            }
            case 'numeric': {
                this.inferredType = 'text';
                inferredCleaveConfiguration = {
                    numericOnly: true,
                    blocks: [Number.POSITIVE_INFINITY],
                };
                break;
            }
            case 'email': {
                this.inferredType = 'email';
                break;
            }
            default: {
                // Ignore
            }
        }
        // Init cleave if any
        if (this.cleaveConfiguration || inferredCleaveConfiguration) {
            // Custom configuration has higher importance
            this.cleave = new Cleave(this.inputElement.nativeElement, (this.cleaveConfiguration || inferredCleaveConfiguration));
            // Force value update to get it formatted with cleave
            setTimeout((/**
             * @return {?}
             */
            () => {
                if (this.innerValue !== null) {
                    this.writeValue(this.innerValue);
                }
            }), 0);
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        super.ngOnDestroy();
        if (this.cleave) {
            this.cleave.destroy();
        }
    }
    /**
     * @return {?}
     */
    get isFilled() {
        return Boolean(this.innerValue || this.placeholder);
    }
    /**
     * @param {?} obj
     * @return {?}
     */
    writeValue(obj) {
        this.innerValue = obj;
        if (this.cleave) {
            this.cleave.setRawValue(this.innerValue ? String(this.innerValue) : this.innerValue);
            this.innerValue = this.cleave.getFormattedValue();
        }
        this.ref.markForCheck();
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnChange(fn) {
        this.onChange = fn;
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    onBlur($event) {
        this.isFocused = false;
        this.onTouched($event);
    }
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    /**
     * @private
     * @param {?} obj
     * @return {?}
     */
    sanitizeValue(obj) {
        if (!this.cleave) {
            return obj;
        }
        switch (this.type) {
            case 'numeric':
                return (this.cleave.getRawValue() || '').replace(/[^0-9]/, '');
            default: {
                return this.cleave.getRawValue();
            }
        }
    }
    /**
     * @return {?}
     */
    onPaste() {
        if (this.disablePaste) {
            return false;
        }
    }
}
InputTextComponent.decorators = [
    { type: Component, args: [{
                selector: 'wt-input-text',
                template: "<div class=\"wt-input wt-input-text\"\n     [class.wt-input--validate-on-blur]=\"validateOnBlur\"\n     [class.wt-input--focused]=\"isFocused\"\n     [class.wt-input-text--disabled]=\"disabled\"\n>\n  <input class=\"wt-input__input {{additionalClass ? additionalClass : ''}}\"\n         [type]=\"inferredType\"\n         [id]=\"id\"\n         [disabled]=\"disabled\"\n         [class.wt-input__input--filled]=\"isFilled\"\n         [attr.aria-label]=\"ariaLabel ? ariaLabel : null\"\n         [attr.placeholder]=\"placeholder ? placeholder : null\"\n         [attr.maxlength]=\"maxLength ? maxLength : null\"\n         (blur)=\"onBlur(value)\"\n         (keyup)=\"onKeyup(value)\"\n         (focus)=\"onFocus()\"\n         [(ngModel)]=\"value\"\n         (paste)=\"onPaste()\"\n         #inputText\n  />\n  <label class=\"wt-input__label\"\n         *ngIf=\"label\"\n         [for]=\"id\"\n  >\n    {{label}}\n  </label>\n  <div class=\"wt-input__error\" *ngIf=\"isInvalid && (!validateOnBlur || !isFocused)\">\n    {{errorMessage}}\n  </div>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef((/**
                         * @return {?}
                         */
                        () => InputTextComponent)),
                        multi: true
                    }]
            }] }
];
/** @nocollapse */
InputTextComponent.ctorParameters = () => [
    { type: Injector }
];
InputTextComponent.propDecorators = {
    disabled: [{ type: Input }],
    placeholder: [{ type: Input }],
    type: [{ type: Input }],
    additionalClass: [{ type: Input }],
    cleaveConfiguration: [{ type: Input }],
    disablePaste: [{ type: Input }],
    inputElement: [{ type: ViewChild, args: ['inputText', { static: true },] }]
};
if (false) {
    /** @type {?} */
    InputTextComponent.prototype.disabled;
    /** @type {?} */
    InputTextComponent.prototype.placeholder;
    /** @type {?} */
    InputTextComponent.prototype.type;
    /** @type {?} */
    InputTextComponent.prototype.additionalClass;
    /** @type {?} */
    InputTextComponent.prototype.cleaveConfiguration;
    /** @type {?} */
    InputTextComponent.prototype.disablePaste;
    /** @type {?} */
    InputTextComponent.prototype.inputElement;
    /** @type {?} */
    InputTextComponent.prototype.inferredType;
    /** @type {?} */
    InputTextComponent.prototype.onTouched;
    /**
     * @type {?}
     * @private
     */
    InputTextComponent.prototype.innerValue;
    /**
     * @type {?}
     * @private
     */
    InputTextComponent.prototype.cleave;
    /**
     * @type {?}
     * @private
     */
    InputTextComponent.prototype.onChange;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ModalComponent {
    /**
     * @param {?} cdr
     * @param {?} overlayPositionBuilder
     * @param {?} viewContainerRef
     * @param {?} elementRef
     * @param {?} overlay
     */
    constructor(cdr, overlayPositionBuilder, viewContainerRef, elementRef, overlay) {
        this.cdr = cdr;
        this.overlayPositionBuilder = overlayPositionBuilder;
        this.viewContainerRef = viewContainerRef;
        this.elementRef = elementRef;
        this.overlay = overlay;
        this.isOpen = false;
        this.additionalClasses = [];
        this.close = new EventEmitter();
        this.subscriptions = new Subscription();
        this.setModalPosition();
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        this.updateModalState(this.isOpen);
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.updateModalState(false);
        this.subscriptions.unsubscribe();
    }
    /**
     * @private
     * @return {?}
     */
    setModalPosition() {
        // Overlay configurations
        /** @type {?} */
        const positionStrategy = this.overlayPositionBuilder
            .global()
            .centerHorizontally()
            .centerVertically();
        /** @type {?} */
        const hasBackdrop = true;
        /** @type {?} */
        const scrollStrategy = this.overlay.scrollStrategies.block();
        // Overlay creation
        this.overlayRef = this.overlay.create({
            positionStrategy,
            hasBackdrop,
            scrollStrategy
        });
        // Overlay on close behaviour
        this.subscriptions.add(this.overlayRef.backdropClick().subscribe((/**
         * @return {?}
         */
        () => {
            this.close.emit();
        })));
    }
    /**
     * @return {?}
     */
    onCloseButtonClick() {
        this.close.emit();
    }
    /**
     * @private
     * @param {?} isOpen
     * @return {?}
     */
    updateModalState(isOpen) {
        if (isOpen && !this.overlayRef.hasAttached()) {
            /** @type {?} */
            const modalPortal = new TemplatePortal(this.wtModal, this.viewContainerRef);
            this.overlayRef.attach(modalPortal);
        }
        else {
            this.overlayRef.detach();
        }
    }
}
ModalComponent.decorators = [
    { type: Component, args: [{
                selector: 'wt-modal',
                template: "<ng-template #wtModal>\n  <div class=\"wt-modal\" [ngClass]=\"additionalClasses\" [class.wt-modal--with-close]=\"showCloseButton\">\n    <div *ngIf=\"showCloseButton\" class=\"wt-modal__close-button\" (click)=\"onCloseButtonClick()\"></div>\n    <ng-content></ng-content>\n  </div>\n</ng-template>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }] }
];
/** @nocollapse */
ModalComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: OverlayPositionBuilder },
    { type: ViewContainerRef },
    { type: ElementRef },
    { type: Overlay }
];
ModalComponent.propDecorators = {
    isOpen: [{ type: Input }],
    additionalClasses: [{ type: Input }],
    showCloseButton: [{ type: Input }],
    close: [{ type: Output }],
    wtModal: [{ type: ViewChild, args: ['wtModal', { static: true },] }]
};
if (false) {
    /** @type {?} */
    ModalComponent.prototype.isOpen;
    /** @type {?} */
    ModalComponent.prototype.additionalClasses;
    /** @type {?} */
    ModalComponent.prototype.showCloseButton;
    /** @type {?} */
    ModalComponent.prototype.close;
    /** @type {?} */
    ModalComponent.prototype.wtModal;
    /**
     * @type {?}
     * @private
     */
    ModalComponent.prototype.overlayRef;
    /**
     * @type {?}
     * @private
     */
    ModalComponent.prototype.subscriptions;
    /**
     * @type {?}
     * @private
     */
    ModalComponent.prototype.cdr;
    /**
     * @type {?}
     * @private
     */
    ModalComponent.prototype.overlayPositionBuilder;
    /**
     * @type {?}
     * @private
     */
    ModalComponent.prototype.viewContainerRef;
    /**
     * @type {?}
     * @private
     */
    ModalComponent.prototype.elementRef;
    /**
     * @type {?}
     * @private
     */
    ModalComponent.prototype.overlay;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ProgressBarComponent {
    constructor() {
        this.progress = 0;
    }
}
ProgressBarComponent.decorators = [
    { type: Component, args: [{
                selector: 'wt-progress-bar',
                template: "<div class=\"wt-progress-bar\">\n  <div class=\"wt-progress-bar__progress\"\n       [ngStyle]=\"{'width': progress + '%'}\">\n  </div>\n</div>\n"
            }] }
];
ProgressBarComponent.propDecorators = {
    progress: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    ProgressBarComponent.prototype.progress;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class StepsBarComponent {
    constructor() {
        this.showActiveLabel = true;
        this.showAllLabels = true;
        this.activeStepIndex = -1;
    }
    /**
     * @return {?}
     */
    ngOnChanges() {
        this.activeStepIndex = this.findIndexOfStep(this.activeStep);
    }
    /**
     * @param {?} step
     * @return {?}
     */
    isActive(step) {
        /** @type {?} */
        const stepIdIndex = this.findIndexOfStep(step);
        return (stepIdIndex >= 0) && (stepIdIndex <= this.activeStepIndex);
    }
    /**
     * @private
     * @param {?} item
     * @return {?}
     */
    findIndexOfStep(item) {
        if (!item) {
            return -1;
        }
        return this.steps.findIndex((/**
         * @param {?} stepBarItem
         * @return {?}
         */
        (stepBarItem) => {
            return stepBarItem.id === item.id;
        }));
    }
}
StepsBarComponent.decorators = [
    { type: Component, args: [{
                selector: 'wt-steps-bar',
                template: "<div class=\"wt-steps-bar\">\n  <div class=\"wt-steps-bar__item\" *ngFor=\"let step of steps\">\n    <wt-steps-bar-item [showActiveLabel]=\"showActiveLabel\" [showAllLabels]=\"showAllLabels\" [label]=\"step.label\" [isActive]=\"isActive(step)\"></wt-steps-bar-item>\n  </div>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }] }
];
StepsBarComponent.propDecorators = {
    steps: [{ type: Input }],
    activeStep: [{ type: Input }],
    showActiveLabel: [{ type: Input }],
    showAllLabels: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    StepsBarComponent.prototype.steps;
    /** @type {?} */
    StepsBarComponent.prototype.activeStep;
    /** @type {?} */
    StepsBarComponent.prototype.showActiveLabel;
    /** @type {?} */
    StepsBarComponent.prototype.showAllLabels;
    /**
     * @type {?}
     * @private
     */
    StepsBarComponent.prototype.activeStepIndex;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class StepsBarItemComponent {
    constructor() {
        this.showActiveLabel = true;
        this.showAllLabels = true;
    }
}
StepsBarItemComponent.decorators = [
    { type: Component, args: [{
                selector: 'wt-steps-bar-item',
                template: "<div class=\"wt-steps-bar-item\" [class.wt-steps-bar-item--active]=\"isActive\">\n  <label class=\"wt-text-base-m wt-steps-bar-item__label\" *ngIf=\"(isActive && showActiveLabel) || showAllLabels\">{{ label }}</label>\n  <div class=\"wt-steps-bar-item__progress\"></div>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }] }
];
StepsBarItemComponent.propDecorators = {
    label: [{ type: Input }],
    isActive: [{ type: Input }],
    showActiveLabel: [{ type: Input }],
    showAllLabels: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    StepsBarItemComponent.prototype.label;
    /** @type {?} */
    StepsBarItemComponent.prototype.isActive;
    /** @type {?} */
    StepsBarItemComponent.prototype.showActiveLabel;
    /** @type {?} */
    StepsBarItemComponent.prototype.showAllLabels;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TooltipDirective {
    /**
     * @param {?} overlayPositionBuilder
     * @param {?} elementRef
     * @param {?} overlay
     */
    constructor(overlayPositionBuilder, elementRef, overlay) {
        this.overlayPositionBuilder = overlayPositionBuilder;
        this.elementRef = elementRef;
        this.overlay = overlay;
    }
    /**
     * @return {?}
     */
    show() {
        /** @type {?} */
        const tooltipPortal = new ComponentPortal(TooltipComponent);
        /** @type {?} */
        const tooltipRef = this.overlayRef.attach(tooltipPortal);
        tooltipRef.instance.text = this.text;
    }
    /**
     * @return {?}
     */
    hide() {
        this.overlayRef.detach();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.setTooltipPosition();
    }
    /**
     * @private
     * @return {?}
     */
    setTooltipPosition() {
        /** @type {?} */
        const positionStrategy = this.overlayPositionBuilder
            .flexibleConnectedTo(this.elementRef)
            .withPositions([{
                originX: 'center',
                originY: 'top',
                overlayX: 'center',
                overlayY: 'bottom'
            }]);
        this.overlayRef = this.overlay.create({ positionStrategy });
    }
}
TooltipDirective.decorators = [
    { type: Directive, args: [{
                selector: '[wtTooltip]'
            },] }
];
/** @nocollapse */
TooltipDirective.ctorParameters = () => [
    { type: OverlayPositionBuilder },
    { type: ElementRef },
    { type: Overlay }
];
TooltipDirective.propDecorators = {
    text: [{ type: Input }],
    show: [{ type: HostListener, args: ['mouseenter',] }],
    hide: [{ type: HostListener, args: ['mouseout',] }]
};
if (false) {
    /** @type {?} */
    TooltipDirective.prototype.text;
    /**
     * @type {?}
     * @private
     */
    TooltipDirective.prototype.overlayRef;
    /**
     * @type {?}
     * @private
     */
    TooltipDirective.prototype.overlayPositionBuilder;
    /**
     * @type {?}
     * @private
     */
    TooltipDirective.prototype.elementRef;
    /**
     * @type {?}
     * @private
     */
    TooltipDirective.prototype.overlay;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class UiKitLibModule {
}
UiKitLibModule.decorators = [
    { type: NgModule, args: [{
                entryComponents: [
                    TooltipComponent,
                    SpinnerComponent
                ],
                declarations: [
                    AccordionComponent,
                    BacklinkComponent,
                    ButtonComponent,
                    FooterComponent,
                    HeaderComponent,
                    InfoBoxComponent,
                    InfoNoteComponent,
                    InputCheckboxComponent,
                    InputCreditcardComponent,
                    InputDateComponent,
                    InputRadioComponent,
                    InputSelectComponent,
                    InputSelectAutocompleteComponent,
                    InputTextComponent,
                    ModalComponent,
                    ProgressBarComponent,
                    StepsBarComponent,
                    StepsBarItemComponent,
                    TooltipComponent,
                    TooltipDirective,
                    SpinnerComponent
                ],
                exports: [
                    AccordionComponent,
                    BacklinkComponent,
                    ButtonComponent,
                    FooterComponent,
                    HeaderComponent,
                    InfoBoxComponent,
                    InfoNoteComponent,
                    InputCheckboxComponent,
                    InputCreditcardComponent,
                    InputDateComponent,
                    InputRadioComponent,
                    InputSelectAutocompleteComponent,
                    InputSelectComponent,
                    InputTextComponent,
                    ModalComponent,
                    ProgressBarComponent,
                    StepsBarComponent,
                    StepsBarItemComponent,
                    TooltipDirective,
                    SpinnerComponent
                ],
                imports: [
                    // Core
                    CommonModule,
                    // Angular deps
                    FormsModule,
                    OverlayModule,
                    ReactiveFormsModule,
                    // External deps
                    NgSelectModule,
                    PortalModule
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function StepsBarItem() { }
if (false) {
    /** @type {?} */
    StepsBarItem.prototype.id;
    /** @type {?} */
    StepsBarItem.prototype.label;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { INPUT_BASE_ERROR_PREFIX, INPUT_DATE_TYPE, INPUT_SIZES, INPUT_WEIGHTS, SpinnerComponent, TooltipComponent, UiKitLibModule, AccordionComponent as ɵa, BacklinkComponent as ɵb, ButtonComponent as ɵc, FooterComponent as ɵd, HeaderComponent as ɵe, InfoBoxComponent as ɵf, InfoNoteComponent as ɵg, InputCheckboxComponent as ɵh, InputBaseComponent as ɵi, InputCreditcardComponent as ɵj, InputDateComponent as ɵk, InputRadioComponent as ɵl, InputSelectComponent as ɵm, InputSelectAutocompleteComponent as ɵn, InputTextComponent as ɵo, ModalComponent as ɵp, ProgressBarComponent as ɵq, StepsBarComponent as ɵr, StepsBarItemComponent as ɵs, TooltipDirective as ɵt };
//# sourceMappingURL=ui-kit-lib.js.map
